<script>
  import { user } from "./stores/user.js";
  import { onMount, onDestroy } from "svelte";
  // import { cooldown } from "./stores/cooldownTimer.js";
  import { tick } from "svelte";
  import { settings } from "./firebase.js";
  import { station } from "./stores/station.js";

  export let cooldownTimer;

  let circle;

  let usCooldown;

  onMount(() => {
    usCooldown = cooldownTimer.subscribe(async (cd) => {
      if ($station && cd.show) {
        let duration = cd.duration;
        let startOffset = Math.round(
          (1 - duration / $station.settings.WAIT) * -100,
        );

        circle.style.strokeDashoffset = `${startOffset}`;

        // await tick();

        setTimeout(() => {
          circle.style.transition = `stroke-dashoffset ${duration}ms linear, stroke ${duration}ms linear`;
          setTimeout(() => {
            circle.style.strokeDashoffset = "-99";
            circle.style.stroke = "#5dff43d5";
          }, 500);
        }, 500);

        // await tick();
      } else {
        circle.style.transition = "";
        circle.style.strokeDashoffset = 0;
        circle.stroke = "#ff9438d5";
      }
    });
  });

  onDestroy(() => {
    usCooldown();
    cooldownTimer.set({ show: false, duration: -1 });
  });
</script>

<div
  class="timer"
  style="visibility: {$cooldownTimer.show ? 'visible' : 'hidden'}"
>
  <svg class="red" width="100" height="100">
    <circle
      bind:this={circle}
      class="circle"
      cx="40"
      cy="40"
      r="33"
      pathlength="100"
    />
  </svg>
</div>

<style>
  .timer {
    width: 100%;
    height: 100%;
    display: contents;
    visibility: hidden;
  }
  .red {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9999;
    overflow: visible;
  }

  .circle {
    fill: none;
    stroke-width: 7;
    stroke-linecap: round;
    stroke: #ff9538d5;
    stroke-dasharray: 100 100;
  }
</style>
